import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=4af2fba9&scoped=true"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"
import style0 from "./MenuItems.vue?vue&type=style&index=0&id=4af2fba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2fba9",
  null
  
)

export default component.exports